import { render, staticRenderFns } from "./newAddrEntry.vue?vue&type=template&id=23b81464&scoped=true&"
import script from "./newAddrEntry.vue?vue&type=script&lang=js&"
export * from "./newAddrEntry.vue?vue&type=script&lang=js&"
import style0 from "./newAddrEntry.vue?vue&type=style&index=0&id=23b81464&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b81464",
  null
  
)

export default component.exports